import * as React from 'react';
import { st, classes } from './WeeklyDateNavigation.st.css';
import localeUtilsFactory from 'wix-style-react-tpa/dist/es/src/common/LocaleUtils/LocaleUtils';
import { getWeekDatesRange } from './dateUtils/dateUtils';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { IconButton } from '../IconButton';
import { ChevronLeft, ChevronRight } from '@wix/wix-ui-icons-common/on-stage';
import { Text } from '../Text';
import { DATA_HOOKS } from './constants';
import { addWeeks } from 'date-fns';
/** A Date navigation. */
export class WeeklyDateNavigation extends React.PureComponent {
    constructor() {
        super(...arguments);
        this._calculateNewWeekDatesRange = (offset) => {
            const { value: { startOfWeek }, locale, firstDayOfWeek, } = this.props;
            const { getFirstDayOfWeek } = localeUtilsFactory(locale, firstDayOfWeek);
            const firstDayOfTheWeek = getFirstDayOfWeek();
            const newStartOfWeek = addWeeks(startOfWeek, offset);
            return getWeekDatesRange(newStartOfWeek, firstDayOfTheWeek);
        };
        this._navigateToNextDatesRange = () => {
            const nextRange = this._calculateNewWeekDatesRange(1);
            this.props.onChange(nextRange);
        };
        this._navigateToPreviousDatesRange = () => {
            const prevRange = this._calculateNewWeekDatesRange(-1);
            this.props.onChange(prevRange);
        };
    }
    _getCaptionText() {
        const { value: { startOfWeek, endOfWeek }, locale, firstDayOfWeek, } = this.props;
        const { formatMonthAndYear, formatMonthsRange } = localeUtilsFactory(locale, firstDayOfWeek);
        if (startOfWeek.getMonth() === endOfWeek.getMonth()) {
            return formatMonthAndYear(endOfWeek);
        }
        return formatMonthsRange(startOfWeek, endOfWeek);
    }
    render() {
        const { className, prevArrowAriaLabel, prevArrowAriaLabelledBy, nextArrowAriaLabel, nextArrowAriaLabelledBy, captionId, } = this.props;
        return (React.createElement(TPAComponentsConsumer, null, ({ rtl }) => {
            return (React.createElement("div", { "data-hook": this.props['data-hook'], className: st(classes.root, { rtl }, className) },
                React.createElement(IconButton, { className: classes.arrow, icon: React.createElement(ChevronLeft, null), "data-hook": DATA_HOOKS.Prev, onClick: this._navigateToPreviousDatesRange, "aria-labelledby": prevArrowAriaLabelledBy, "aria-label": prevArrowAriaLabel }),
                React.createElement(Text, { id: captionId, "data-hook": DATA_HOOKS.Text, className: classes.text }, this._getCaptionText()),
                React.createElement(IconButton, { className: classes.arrow, icon: React.createElement(ChevronRight, null), "data-hook": DATA_HOOKS.Next, onClick: this._navigateToNextDatesRange, "aria-labelledby": nextArrowAriaLabelledBy, "aria-label": nextArrowAriaLabel })));
        }));
    }
}
WeeklyDateNavigation.displayName = 'WeeklyDateNavigation';
WeeklyDateNavigation.defaultProps = {
    locale: 'en',
};
//# sourceMappingURL=WeeklyDateNavigation.js.map